import React from "react";
import { useSelector } from "react-redux";
import B2BCustomerTable from "./B2BCustomerTable";
import B2CCustomerTable from "./B2CCustomerTable";

const CustomersTableWrapper = () => {
  const tenantClientData = useSelector((state) => state.clients);
  const isB2C =
    tenantClientData?.selectedClient?.label?.toLowerCase() === "b2c" ||
    tenantClientData?.selectedClient?.value === "cyberior";

  // The "Programs & Slugs" button now lives next to the Get Template button
  // inside each customer table (B2C / B2B), not floating at the top.
  return <>{isB2C ? <B2CCustomerTable /> : <B2BCustomerTable />}</>;
};

export default CustomersTableWrapper;
